import React, { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import { UserForm } from "../UserForm";

import { useAddUserForm } from "./hooks";

const UserAdd: FC = () => {
  const form = useAddUserForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Add user" />
        </Typography.Title>
      </Header>
      <Space />
      <UserForm {...form} />
    </>
  );
};

export default UserAdd;
